module.exports = __webpack_public_path__ + "img/ic_minus.c9c11fa6.svg";